export default __webpack_public_path__ + "static/media/screen5.183a8bc4.png";